<template>
  <div class="jyd" v-if="$COMPANY_NAME === 'jyd'"></div>
  <div class="kr" v-else-if="$COMPANY_NAME === 'kr'"></div>
  <div :class="{ showCard: isShowCard, hiddenCard: !isShowCard }" v-else>
    <div class="home-title">专注工程类保函·您的信心之选</div>
    <template v-if="isShowCard">
      <transition name="el-fade-in-linear" :duration="3000">
        <div class="card" v-show="show">
          <div class="card-item" @click="jumpCrm('crm')">
            <div class="card-item-left">
              <img src="/static/picture/crm-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">CRM客户管理系统</div>
              <div class="card-item-subtitle">CRM客户管理系统</div>
            </div>
          </div>
          <div class="card-item" @click="jumpCrm('oms')">
            <div class="card-item-left">
              <img src="/static/picture/oms-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">OMS运营管理系统</div>
              <div class="card-item-subtitle">OMS运营管理系统</div>
            </div>
          </div>
          <div class="card-item" @click="jumpCrm('rm')">
            <div class="card-item-left">
              <img src="/static/picture/rm-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">RM风险管理系统</div>
              <div class="card-item-subtitle">Risk Management 企业风险评估</div>
            </div>
          </div>
          <div class="card-item" @click="jumpCrm('fms')">
            <div class="card-item-left">
              <img src="/static/picture/fms-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">FMS财务管理系统</div>
              <div class="card-item-subtitle">FMS财务进销存管理系统</div>
            </div>
          </div>
          <div class="card-item" @click="jumpCrm('ehr')">
            <div class="card-item-left">
              <img src="/static/picture/ehr-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">eHR人力资源管理系统</div>
              <div class="card-item-subtitle">eHR人力资源管理系统</div>
            </div>
          </div>
          <div class="card-item" @click="jumpCrm('BI')">
            <div class="card-item-left">
              <img src="/static/picture/bi-icon.png" alt="" />
            </div>
            <div class="card-item-right">
              <div class="card-item-title">BI数据可视化统计</div>
              <div class="card-item-subtitle">BIPlus 企业数据可视化分析系统</div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <img src="/static/picture/home-cover.png" alt="" class="home-cover" />
    </template>
  </div>
</template>
<script>
export default {
  name: 'home',
  data() {
    return {
      show: false,
      isShowCard: this.$ENV.HOME_SHOW_SYSTEM,
    };
  },
  created() {
    this.$nextTick(() => (this.show = true));
  },
  methods: {
    jumpCrm(sysName) {
      switch (sysName) {
        case 'crm':
          this.$router.push('/crm/CrmSysNav');
          break;
        case 'rm':
          this.$router.push('/rm/RmSysNav');
          break;
        case 'oms':
          this.$router.push('/oms/OmsSysNav');
          break;
        case 'fms':
          this.$router.push('/fms/FmsSysNav');
          break;
        case 'ehr':
          this.$router.push('/ehr/EhrSysNav');
          break;
        case 'BI':
          this.$router.push('/BI/financeNav');
          break;
        default:
          this.$message.warning('页面不存在或无页面权限');
          break;
      }
    },
  },
};
</script>
<style scoped lang="less">
@import '../../style/home.less';
.jyd {
  width: 100%;
  height: 100%;
  background: url(/static/picture/home-cover_jyd.png) no-repeat center/100% 100%;
  img {
    width: 546px;
    height: 433px;
  }
}
.kr {
  width: 100%;
  height: 100%;
  background: url(/static/picture/home-cover_kr.png) no-repeat center/100% 100%;
  img {
    width: 546px;
    height: 433px;
  }
}
</style>
